import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

// temporary function to resolve a withRouter function, need to remove and use hooks and function components as well
export function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    return <Component {...props} router={{ location, navigate, params }} />;
  }

  return ComponentWithRouterProp;
}
